import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const getAttachmentsByName = async (value) => {
  return await request.get(
    '/HousingStock/transport/attachments',
    value,
    'При загрузке данных документа произошла ошибка',
    'Error'
  );
};

const useAttachmentsByName = () =>
  useMutation(getAttachmentsByName, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

export default useAttachmentsByName;
